export enum TripTypeFilter {
  None = 0,
  Customer = 1,
  Business = 2
}